import {
  Home,
  AlertTriangle,
  Route as RouteIcon,
  LayoutGrid,
  BarChart3,
  Users,
  Send,
} from "lucide-react";
import { PageLayout } from "@/components/PageLayout";
import { Hero } from "@/components/sections/Hero";
import { Marquee } from "@/components/sections/Marquee";
import { Problem } from "@/components/sections/Problem";
import { Manifesto } from "@/components/sections/Manifesto";
import { BentoFeatures } from "@/components/sections/BentoFeatures";
import { Measurability } from "@/components/sections/Measurability";
import { Audiences } from "@/components/sections/Audiences";
import { CTA } from "@/components/sections/CTA";

// Bogen der Seite: erst die Frage, dann die Plattform und direkt danach ihre
// Zuspitzung auf das Belegen, dann die Weiche zu den Zielgruppenseiten. Der
// Ablauf steht als Kurzfassung am Ende und führt in den Kontakt über.
const SIDEBAR_ITEMS = [
  { id: "top", label: "Start", icon: Home },
  { id: "problem", label: "Die Ausgangslage", icon: AlertTriangle },
  { id: "plattform", label: "Die Plattform", icon: LayoutGrid },
  { id: "messbarkeit", label: "Der Kern", icon: BarChart3 },
  { id: "zielgruppen", label: "Für wen", icon: Users },
  { id: "ablauf", label: "So läuft es ab", icon: RouteIcon },
  { id: "cta", label: "Kontakt", icon: Send },
];

export default function Landing() {
  return (
    <PageLayout sidebarItems={SIDEBAR_ITEMS} testId="landing-main">
      <Hero />
      <Marquee />
      <Problem />
      <BentoFeatures />
      <Measurability />
      <Audiences />
      <Manifesto />
      <CTA />
    </PageLayout>
  );
}
